/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./resources/app.ts":
/*!**************************!*\
  !*** ./resources/app.ts ***!
  \**************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _components_DataLayer_DataLayer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @components/DataLayer/DataLayer */ "./resources/scripts/components/DataLayer/DataLayer.ts");
/* harmony import */ var _scripts_components_Consent_Consent__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./scripts/components/Consent/Consent */ "./resources/scripts/components/Consent/Consent.ts");
/* harmony import */ var _scripts_components_ReadMoreCollection_ReadMoreCollection__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./scripts/components/ReadMoreCollection/ReadMoreCollection */ "./resources/scripts/components/ReadMoreCollection/ReadMoreCollection.ts");
/* harmony import */ var _scripts_components_Bundle_Bundle__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./scripts/components/Bundle/Bundle */ "./resources/scripts/components/Bundle/Bundle.ts");
/* harmony import */ var _scripts_components_VideoReviews_VideoReviews__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./scripts/components/VideoReviews/VideoReviews */ "./resources/scripts/components/VideoReviews/VideoReviews.ts");
/* DataLayer */

/* Content */

/* ReadMoreCollection */

/* Bundle */

/* Video Reviews */

customElements.define("video-reviews", _scripts_components_VideoReviews_VideoReviews__WEBPACK_IMPORTED_MODULE_4__["default"]);
customElements.define("bundle-component", _scripts_components_Bundle_Bundle__WEBPACK_IMPORTED_MODULE_3__["default"]);
var consent = new _scripts_components_Consent_Consent__WEBPACK_IMPORTED_MODULE_1__["default"]();
consent.init();
var editionDataLayer = new _components_DataLayer_DataLayer__WEBPACK_IMPORTED_MODULE_0__["default"]();
editionDataLayer.init();
(0,_scripts_components_ReadMoreCollection_ReadMoreCollection__WEBPACK_IMPORTED_MODULE_2__["default"])();

/***/ }),

/***/ "./resources/scripts/components/Bundle/Bundle.ts":
/*!*******************************************************!*\
  !*** ./resources/scripts/components/Bundle/Bundle.ts ***!
  \*******************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ Bundle)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* eslint-disable prefer-arrow-callback */
/* eslint-disable func-names */
/* eslint-disable prefer-template */
/* eslint-disable class-methods-use-this */
/* eslint-disable consistent-return */
/* eslint-disable no-console */
var Bundle = /*#__PURE__*/function (_HTMLElement) {
  function Bundle() {
    var _this;
    _classCallCheck(this, Bundle);
    _this = _callSuper(this, Bundle);
    _defineProperty(_this, "bundleItems", Array.from(_this.querySelectorAll(".bundle-item")));
    _defineProperty(_this, "addToCartButton", _this.closest(".product").querySelector("buy-buttons").querySelector('button[type="submit"]'));
    _defineProperty(_this, "productUrl", _this.dataset.producturl);
    _defineProperty(_this, "loadingOverlay", _this.querySelector(".loading-overlay"));
    _this.initEventListeners = _this.initEventListeners.bind(_this);
    _this.moveOverlaysOutOfMain = _this.moveOverlaysOutOfMain.bind(_this);
    _this.toggleBundleItemDrawer = _this.toggleBundleItemDrawer.bind(_this);
    _this.addBundleDrawerEventListeners = _this.addBundleDrawerEventListeners.bind(_this);
    _this.handleSizeSelectChange = _this.handleSizeSelectChange.bind(_this);
    _this.addToBundle = _this.addToBundle.bind(_this);
    _this.toggleDisableStateAddToCartButton = _this.toggleDisableStateAddToCartButton.bind(_this);
    _this.handleAddBundleToCart = _this.handleAddBundleToCart.bind(_this);
    _this.toggleCartDrawer = _this.toggleCartDrawer.bind(_this);
    return _this;
  }
  _inherits(Bundle, _HTMLElement);
  return _createClass(Bundle, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this.toggleDisableStateAddToCartButton(this.addToCartButton);
      this.moveOverlaysOutOfMain();
      this.initEventListeners();
    }
  }, {
    key: "initEventListeners",
    value: function initEventListeners() {
      var _this2 = this;
      this.bundleItems.forEach(function (item) {
        item.addEventListener("click", function (event) {
          event.preventDefault();
          _this2.handleBundleItemClicked(item);
        });
      });
      this.addToCartButton.addEventListener("click", /*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(event) {
          return _regenerator().w(function (_context) {
            while (1) switch (_context.n) {
              case 0:
                event.preventDefault();
                _context.n = 1;
                return _this2.handleAddBundleToCart();
              case 1:
                return _context.a(2);
            }
          }, _callee);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "handleBundleItemClicked",
    value: function handleBundleItemClicked(item) {
      this.toggleBundleItemDrawer(item);
    }
    // Theme specific methods to move overlays ontop of the header
  }, {
    key: "moveOverlaysOutOfMain",
    value: function moveOverlaysOutOfMain() {
      var overlays = Array.from(this.querySelectorAll(".bundle-item-overlay"));
      overlays.forEach(function (overlay) {
        document.body.appendChild(overlay);
      });
    }
  }, {
    key: "toggleBundleItemDrawer",
    value: function toggleBundleItemDrawer(item) {
      var itemId = item.id;
      var overlay = document.querySelector(".bundle-item-overlay[data-target=\"".concat(itemId, "\"]"));
      var drawer = overlay.querySelector(".bundle-item-drawer");
      var isCurrentlyOpen = overlay.getAttribute("aria-hidden") === "false";
      if (isCurrentlyOpen) {
        // Animate out
        drawer.style.transform = "translateX(100%)";
        setTimeout(function () {
          overlay.setAttribute("aria-hidden", "true");
          drawer.setAttribute("aria-hidden", "true");
          document.body.style.overflow = "";
        }, 250); // Wait for the transition before hiding
      } else {
        // Open the overlay immediately
        overlay.setAttribute("aria-hidden", "false");
        document.body.style.overflow = "hidden";
        setTimeout(function () {
          drawer.setAttribute("aria-hidden", "false");
          drawer.style.transform = "translateX(0)";
        }, 1);
      }
      this.addBundleDrawerEventListeners(overlay, item);
    }
  }, {
    key: "addBundleDrawerEventListeners",
    value: function addBundleDrawerEventListeners(overlay, item) {
      var _this3 = this;
      var closeBundleToggle = overlay.querySelector(".overlay-toggle");
      // Only add the event listener once
      if (!closeBundleToggle.hasAttribute("data-event-listener")) {
        closeBundleToggle.addEventListener("click", function (event) {
          event.preventDefault();
          _this3.toggleBundleItemDrawer(item);
        });
        closeBundleToggle.setAttribute("data-event-listener", "true");
      }
      // if clicking on the overlay, close the drawer
      overlay.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        if (event.target === overlay) {
          _this3.toggleBundleItemDrawer(item);
        }
      });
      var selectSizeElements = Array.from(overlay.querySelectorAll("select"));
      selectSizeElements.forEach(function (select) {
        if (!select.hasAttribute("data-event-listener")) {
          select.addEventListener("change", function () {
            _this3.handleSizeSelectChange(select);
          });
          select.setAttribute("data-event-listener", "true");
        }
      });
      var addToBundleButtons = Array.from(overlay.querySelectorAll(".add-to-bundle"));
      addToBundleButtons.forEach(function (button) {
        if (!button.hasAttribute("data-event-listener")) {
          button.addEventListener("click", function (event) {
            event.preventDefault();
            _this3.addToBundle(button);
          });
          button.setAttribute("data-event-listener", "true");
        }
      });
    }
    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "handleSizeSelectChange",
    value: function handleSizeSelectChange(select) {
      var closestBundleItem = select.closest(".bundle-item-info-wrapper");
      var addToBundleButton = closestBundleItem.querySelector(".add-to-bundle");
      addToBundleButton.setAttribute("data-id", select.value);
      addToBundleButton.setAttribute("data-title", select.options[select.selectedIndex].dataset.title);
    }
  }, {
    key: "addToBundle",
    value: function addToBundle(button) {
      var _button$dataset = button.dataset,
        color = _button$dataset.color,
        id = _button$dataset.id,
        image = _button$dataset.image,
        title = _button$dataset.title;
      // Get the id of the drawer, so we can find the corresponding item
      var closestOverlay = button.closest(".bundle-item-overlay");
      var overlayId = closestOverlay.getAttribute("data-target");
      // Get the item that corresponds to the overlay
      var item = document.querySelector("#".concat(overlayId));
      // mark the bundle as selected
      item.setAttribute("aria-selected", "true");
      var bundleItemInfoWrapper = item.querySelector(".bundle-item-selection");
      // replace the image with the selected image
      var imageElement = bundleItemInfoWrapper.querySelector(".bundle-item-image");
      imageElement.src = image;
      // replace the color with the selected color
      var colorElement = bundleItemInfoWrapper.querySelector(".bundle-item-color");
      colorElement.textContent = color;
      // replace the title with the selected title
      var titleElement = bundleItemInfoWrapper.querySelector(".bundle-item-title");
      var titleWrapper = item.querySelector(".bundle-title-wrapper");
      if (title === "Default Title") {
        titleElement.textContent = "";
        titleWrapper.classList.add("tw-opacity-0");
      } else {
        titleElement.textContent = title;
        titleWrapper.classList.remove("tw-opacity-0");
      }
      // replace the id with the selected id
      item.setAttribute("data-id", id);
      // close the drawer
      this.toggleBundleItemDrawer(item);
      this.toggleDisableStateAddToCartButton(this.addToCartButton);
    }
  }, {
    key: "toggleDisableStateAddToCartButton",
    value: function toggleDisableStateAddToCartButton(button) {
      button.disabled = this.bundleItems.every(function (item) {
        return item.getAttribute("aria-selected") !== "true";
      });
    }
    // eslint-disable-next-line consistent-return
  }, {
    key: "handleAddBundleToCart",
    value: function () {
      var _handleAddBundleToCart = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var shop, token, bundleComponents, metaobjectId, productId, body, response, refreshedToken, retryResponse, data, bundle, message, variant, _t;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              this.loadingOverlay.style.display = "flex";
              shop = window.Shopify.shop;
              _context2.n = 1;
              return this.getJwtToken(shop);
            case 1:
              token = _context2.v;
              // Get the JWT token (or refresh if expired)
              bundleComponents = this.bundleItems.map(function (item) {
                return item.getAttribute("data-id");
              });
              metaobjectId = this.getAttribute("data-metaobjectid");
              productId = this.getAttribute("data-productid");
              body = {
                productId: productId,
                bundleComponents: bundleComponents,
                metaobjectId: metaobjectId,
                shop: shop
              };
              _context2.n = 2;
              return fetch("http://bundle-app.edition.dk/api/bundle", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer ".concat(token) // Use the JWT token
                },
                body: JSON.stringify(body)
              });
            case 2:
              response = _context2.v;
              if (response.ok) {
                _context2.n = 8;
                break;
              }
              if (!(response.status === 401)) {
                _context2.n = 7;
                break;
              }
              // Token expired or unauthorized
              console.log("Token expired. Attempting to refresh token...");
              _context2.n = 3;
              return this.getJwtToken(window.Shopify.shop);
            case 3:
              refreshedToken = _context2.v;
              _context2.n = 4;
              return fetch("http://bundle-app.edition.dk/api/bundle", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer ".concat(refreshedToken)
                },
                body: JSON.stringify(body)
              });
            case 4:
              retryResponse = _context2.v;
              if (retryResponse.ok) {
                _context2.n = 5;
                break;
              }
              throw new Error("Failed to add bundle to cart");
            case 5:
              _context2.n = 6;
              return retryResponse.json();
            case 6:
              return _context2.a(2, _context2.v);
            case 7:
              throw new Error("Failed to add bundle to cart");
            case 8:
              _context2.n = 9;
              return response.json();
            case 9:
              data = _context2.v;
              // eslint-disable-next-line @typescript-eslint/no-unused-vars
              bundle = data.bundle, message = data.message, variant = data.variant;
              _context2.n = 10;
              return this.addVariantToCart(variant);
            case 10:
              _context2.n = 12;
              break;
            case 11:
              _context2.p = 11;
              _t = _context2.v;
              console.error("Error adding bundle to cart:", _t);
            case 12:
              _context2.p = 12;
              this.loadingOverlay.style.display = "none";
              return _context2.f(12);
            case 13:
              return _context2.a(2);
          }
        }, _callee2, this, [[0, 11, 12, 13]]);
      }));
      function handleAddBundleToCart() {
        return _handleAddBundleToCart.apply(this, arguments);
      }
      return handleAddBundleToCart;
    }() // eslint-disable-next-line class-methods-use-this
  }, {
    key: "toggleCartDrawer",
    value: function toggleCartDrawer() {
      document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
        bubbles: true
      }));
      var cartDrawerTrigger = document.querySelector('a[href="/cart"]');
      cartDrawerTrigger.click();
    }
  }, {
    key: "addVariantToCart",
    value: function () {
      var _addVariantToCart = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(variant) {
        var _this4 = this;
        var response, pollForVariant, interval, _t3;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              _context4.p = 0;
              _context4.n = 1;
              return fetch("/cart/add.js", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json"
                },
                body: JSON.stringify({
                  id: variant,
                  quantity: 1
                })
              });
            case 1:
              response = _context4.v;
              if (response.ok) {
                _context4.n = 2;
                break;
              }
              throw new Error("Failed to add variant to cart");
            case 2:
              // Because the variant we added to cart might be a variant that was just created, it might not just yet be available for the liquid api.
              // therefor we need to poll the product until it is available.
              // once it is we refresh the cart drawer
              pollForVariant = /*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
                  var pollingResponse, _yield$pollingRespons, variants, _t2;
                  return _regenerator().w(function (_context3) {
                    while (1) switch (_context3.p = _context3.n) {
                      case 0:
                        _context3.p = 0;
                        _context3.n = 1;
                        return fetch("".concat(_this4.productUrl, ".json"));
                      case 1:
                        pollingResponse = _context3.v;
                        if (pollingResponse.ok) {
                          _context3.n = 2;
                          break;
                        }
                        throw new Error("Network response was not ok");
                      case 2:
                        _context3.n = 3;
                        return pollingResponse.json();
                      case 3:
                        _yield$pollingRespons = _context3.v;
                        variants = _yield$pollingRespons.product.variants;
                        if (variants.some(function (_variant) {
                          return _variant.id === Number(variant);
                        })) {
                          // eslint-disable-next-line @typescript-eslint/no-use-before-define
                          clearInterval(interval); // Stop polling when the variant is found
                          _this4.toggleCartDrawer();
                          _this4.loadingOverlay.style.display = "none";
                        }
                        _context3.n = 5;
                        break;
                      case 4:
                        _context3.p = 4;
                        _t2 = _context3.v;
                        console.error("Error polling for variant:", _t2);
                      case 5:
                        return _context3.a(2);
                    }
                  }, _callee3, null, [[0, 4]]);
                }));
                return function pollForVariant() {
                  return _ref2.apply(this, arguments);
                };
              }();
              interval = setInterval(pollForVariant, 1500);
              _context4.n = 4;
              break;
            case 3:
              _context4.p = 3;
              _t3 = _context4.v;
              console.error(_t3);
            case 4:
              return _context4.a(2);
          }
        }, _callee4, null, [[0, 3]]);
      }));
      function addVariantToCart(_x2) {
        return _addVariantToCart.apply(this, arguments);
      }
      return addVariantToCart;
    }()
  }, {
    key: "getJwtToken",
    value: function () {
      var _getJwtToken = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(shop) {
        var token, _t4;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              _context5.p = 0;
              token = localStorage.getItem("jwtTokenBundle"); // If no token, or the token is expired, request a new one
              if (!(!token || this.isTokenExpired(token))) {
                _context5.n = 2;
                break;
              }
              console.log("Token expired or missing. Getting a new token...");
              _context5.n = 1;
              return this.refreshJwtToken(shop);
            case 1:
              token = _context5.v;
            case 2:
              return _context5.a(2, token);
            case 3:
              _context5.p = 3;
              _t4 = _context5.v;
              console.error("Failed to get JWT token", _t4);
            case 4:
              return _context5.a(2);
          }
        }, _callee5, this, [[0, 3]]);
      }));
      function getJwtToken(_x3) {
        return _getJwtToken.apply(this, arguments);
      }
      return getJwtToken;
    }() // Check if the token is expired
  }, {
    key: "isTokenExpired",
    value: function isTokenExpired(token) {
      var decodedToken = this.decodeJwtToken(token);
      if (decodedToken && decodedToken.exp) {
        var expiry = decodedToken.exp * 1000; // Convert to milliseconds
        return Date.now() > expiry;
      }
      return false;
    }
    // Decode JWT token (you can use any JWT library here)
  }, {
    key: "decodeJwtToken",
    value: function decodeJwtToken(token) {
      try {
        var base64Url = token.split(".")[1];
        var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
        var jsonPayload = decodeURIComponent(atob(base64).split("").map(function (c) {
          return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(""));
        return JSON.parse(jsonPayload);
      } catch (e) {
        console.error("Failed to decode JWT token", e);
        return null;
      }
    }
    // Refresh the JWT token
  }, {
    key: "refreshJwtToken",
    value: function () {
      var _refreshJwtToken = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(shop) {
        var response, data, jwtToken;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              _context6.n = 1;
              return fetch("http://bundle-app.edition.dk/api/auth", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json"
                },
                body: JSON.stringify({
                  shop: shop
                }) // Send shop identifier
              });
            case 1:
              response = _context6.v;
              if (response.ok) {
                _context6.n = 2;
                break;
              }
              throw new Error("Failed to refresh token");
            case 2:
              _context6.n = 3;
              return response.json();
            case 3:
              data = _context6.v;
              jwtToken = data.token;
              localStorage.setItem("jwtTokenBundle", jwtToken);
              return _context6.a(2, jwtToken);
          }
        }, _callee6);
      }));
      function refreshJwtToken(_x4) {
        return _refreshJwtToken.apply(this, arguments);
      }
      return refreshJwtToken;
    }()
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ }),

/***/ "./resources/scripts/components/Consent/Consent.ts":
/*!*********************************************************!*\
  !*** ./resources/scripts/components/Consent/Consent.ts ***!
  \*********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ Consent)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// Consent Component
//
// This class manages user consent tracking and interaction with Shopify's consent-tracking API.
// It includes methods for initializing consent features, handling consent updates, and interacting
// with Shopify's privacy settings.
//
// Key Functionalities:
// - `init()`: Loads Shopify's consent-tracking API and initializes the consent component.
// - `initConsentComponent()`: Sets up event listeners for consent actions, such as recalling consent preferences.
// - `handleConsentUpdate(state: string)`: Updates consent settings based on the user's current preferences.
//   - Parameters:
//     - `state`: A string representing the consent state ("granted", "denied", etc.).
// - `checkConsentBannerInteraction()`: Verifies if the user has interacted with the consent banner.
// - `gtag(...args)`: Pushes consent-related events to the Google Tag Manager data layer.
// - `recallConsent()`: Displays the privacy banner to allow users to update their consent preferences.
// - `logConsent(consentSettings: object)`: Logs the user's consent preferences to a database or analytics tool.
//
// Dependencies:
// - `window.dataLayer`: Required for Google Consent Mode V2 integration.
// - Shopify Customer Privacy Banner: Must be enabled in the Shopify admin panel.
//
// Error Handling:
// - Errors in loading Shopify features (e.g., API initialization failures) are logged to the console without blocking the process.
//
// Extensibility:
// - Support additional consent categories or analytics tools by extending `handleConsentUpdate` and other methods.
// - Update `logConsent` to integrate with custom databases or third-party analytics platforms as needed.
//
// Notes:
// - Local storage is used to persist consent settings across sessions.
// Usage Example:
// 1. Import the `Consent` class and initialize it in your application:
// ---- import Consent from './scripts/components/Consent/Consent';
// ---- const consent = new Consent();
// ---- consent.init();
//
// 2. To enable the recall consent feature, add an element with the ID "recall-consent" to the DOM:
// ---- <a href="#" id="recall-consent"></a>
//
// 3. Add Locales: en: "change_cookie_settings": "Change your cookie settings", da: "change_cookie_settings": "Tilpas dine cookie-indstillinger",
var Consent = /*#__PURE__*/function () {
  // declare dataLayer
  function Consent() {
    _classCallCheck(this, Consent);
    this.init = this.init.bind(this);
    this.handleConsentUpdate = this.handleConsentUpdate.bind(this);
    this.checkConsentBannerInteraction = this.checkConsentBannerInteraction.bind(this);
    this.gtag = this.gtag.bind(this);
    this.recallConsent = this.recallConsent.bind(this);
  }
  return _createClass(Consent, [{
    key: "init",
    value: function () {
      var _init = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _this = this;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              window.Shopify.loadFeatures([{
                name: "consent-tracking-api",
                version: "0.1"
              }], function (error) {
                if (error) {
                  // eslint-disable-next-line no-console
                  console.error("Error loading features: ", error);
                  return;
                }
                // eslint-disable-next-line no-console
                console.log("Consent tracking API loaded");
                _this.initConsentComponent();
              });
            case 1:
              return _context.a(2);
          }
        }, _callee);
      }));
      function init() {
        return _init.apply(this, arguments);
      }
      return init;
    }()
  }, {
    key: "initConsentComponent",
    value: function () {
      var _initConsentComponent = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var _this2 = this;
        var recallConsentElement;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              window.dataLayer = window.dataLayer || [];
              document.addEventListener("visitorConsentCollected", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
                return _regenerator().w(function (_context2) {
                  while (1) switch (_context2.n) {
                    case 0:
                      _this2.handleConsentUpdate("update");
                    case 1:
                      return _context2.a(2);
                  }
                }, _callee2);
              })));
              recallConsentElement = document.getElementById("recall-consent");
              if (recallConsentElement) {
                recallConsentElement.addEventListener("click", function (event) {
                  event.preventDefault();
                  _this2.recallConsent();
                });
              }
            case 1:
              return _context3.a(2);
          }
        }, _callee3);
      }));
      function initConsentComponent() {
        return _initConsentComponent.apply(this, arguments);
      }
      return initConsentComponent;
    }()
  }, {
    key: "handleConsentUpdate",
    value: function () {
      var _handleConsentUpdate = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(state) {
        var visitorConsent, consent;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _context4.n = 1;
              return window.Shopify.customerPrivacy.currentVisitorConsent();
            case 1:
              visitorConsent = _context4.v;
              consent = {
                functionality_storage: "granted",
                analytics_storage: visitorConsent.analytics === "yes" ? "granted" : "denied",
                personalization_storage: visitorConsent.analytics === "yes" ? "granted" : "denied",
                ad_storage: visitorConsent.marketing === "yes" ? "granted" : "denied",
                ad_user_data: visitorConsent.marketing === "yes" ? "granted" : "denied",
                ad_personalization: visitorConsent.marketing === "yes" ? "granted" : "denied",
                wait_for_update: 3000
              };
              this.gtag("consent", state, consent);
              // set local Storage for consent settings for further use on other pages or after page
              localStorage.setItem("consentSettings", JSON.stringify(consent));
            case 2:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function handleConsentUpdate(_x) {
        return _handleConsentUpdate.apply(this, arguments);
      }
      return handleConsentUpdate;
    }() /* eslint-disable */
  }, {
    key: "checkConsentBannerInteraction",
    value: (function () {
      var _checkConsentBannerInteraction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var visitorConsent;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              _context5.n = 1;
              return window.Shopify.customerPrivacy.currentVisitorConsent();
            case 1:
              visitorConsent = _context5.v;
              if (!(visitorConsent.preferences === "" && visitorConsent.analytics === "" && visitorConsent.marketing === "")) {
                _context5.n = 2;
                break;
              }
              return _context5.a(2, false);
            case 2:
              return _context5.a(2, true);
          }
        }, _callee5);
      }));
      function checkConsentBannerInteraction() {
        return _checkConsentBannerInteraction.apply(this, arguments);
      }
      return checkConsentBannerInteraction;
    }()
    /* eslint-disable */
    /* eslint-disable */
    )
  }, {
    key: "gtag",
    value: function gtag() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      window.dataLayer.push(arguments);
    }
    /* eslint-enable */
    /* eslint-disable */
  }, {
    key: "recallConsent",
    value: (function () {
      var _recallConsent = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              window.privacyBanner.showPreferences();
            case 1:
              return _context6.a(2);
          }
        }, _callee6);
      }));
      function recallConsent() {
        return _recallConsent.apply(this, arguments);
      }
      return recallConsent;
    }())
  }]);
}();


/***/ }),

/***/ "./resources/scripts/components/DataLayer/AccountRegister.ts":
/*!*******************************************************************!*\
  !*** ./resources/scripts/components/DataLayer/AccountRegister.ts ***!
  \*******************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ AccountRegister)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// Datalayer Account Register
var AccountRegister = /*#__PURE__*/function () {
  function AccountRegister() {
    _classCallCheck(this, AccountRegister);
    _defineProperty(this, "dataLayer", window.dataLayer);
    this.init = this.init.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.pushAccountRegisterEvent = this.pushAccountRegisterEvent.bind(this);
    this.pushNewsLetterSubscribeEvent = this.pushNewsLetterSubscribeEvent.bind(this);
  }
  return _createClass(AccountRegister, [{
    key: "init",
    value: function init() {
      var _this = this;
      var accountRegisterForms = Array.from(document.querySelectorAll('form[action="/account"]'));
      if (accountRegisterForms.length >= 1) {
        accountRegisterForms.forEach(function (form) {
          form.addEventListener('submit', function () {
            _this.handleSubmit(form);
          });
        });
      }
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit(form) {
      var firstNameInput = form.querySelector('input[name="customer[first_name]"');
      var lastNameInput = form.querySelector('input[name="customer[last_name]"');
      var emailInput = form.querySelector('input[name="customer[email]"');
      var acceptsMarketingInput = form.querySelector('input[name="customer[accepts_marketing]"');
      var noteInputs = document.querySelectorAll('input[name^="customer[note]"]');
      var notes = [];
      var firstName = firstNameInput ? firstNameInput.value || '' : '';
      var lastName = lastNameInput ? lastNameInput.value || '' : '';
      var email = emailInput ? emailInput.value || '' : '';
      var acceptsMarketing = acceptsMarketingInput && acceptsMarketingInput.checked !== undefined ? acceptsMarketingInput.checked : false;
      if (noteInputs.length >= 1) {
        notes = Array.from(noteInputs).map(function (noteInput) {
          if (noteInput.value === '') return undefined;
          var noteFieldName = noteInput.name.split('customer[note]')[1] || '';
          noteFieldName = noteFieldName.replace('[', '').replace(']', '');
          return "".concat(noteFieldName, ": ").concat(noteInput.value);
        }).filter(function (note) {
          return note !== undefined;
        });
      }
      // Capturing the event in the accountRegisterEventObject
      var accountRegisterEventObject = {
        event: 'edition_account_register',
        signUpMethod: 'email',
        customerFirstName: firstName,
        customerLastName: lastName,
        customerEmail: email,
        acceptsMarketing: acceptsMarketing,
        customerNotes: notes
      };
      this.pushAccountRegisterEvent(accountRegisterEventObject);
      if (acceptsMarketing) {
        var newsLetterSubscribeEventObject = {
          event: 'edition_newsletter_subscribe',
          customerEmail: email
        };
        this.pushNewsLetterSubscribeEvent(newsLetterSubscribeEventObject);
      }
    }
  }, {
    key: "pushAccountRegisterEvent",
    value: function pushAccountRegisterEvent(accountRegisterEventObject) {
      this.dataLayer.push(accountRegisterEventObject);
    }
  }, {
    key: "pushNewsLetterSubscribeEvent",
    value: function pushNewsLetterSubscribeEvent(newsLetterSubscribeEventObject) {
      this.dataLayer.push(newsLetterSubscribeEventObject);
    }
  }]);
}();


/***/ }),

/***/ "./resources/scripts/components/DataLayer/AddToWishlist.ts":
/*!*****************************************************************!*\
  !*** ./resources/scripts/components/DataLayer/AddToWishlist.ts ***!
  \*****************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ ProductAddToWishlist)
/* harmony export */ });
/* harmony import */ var _utils_DatalayerHelpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../utils/DatalayerHelpers */ "./resources/scripts/utils/DatalayerHelpers.ts");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// Datalayer Add to Wishlist
// TODO

var ProductAddToWishlist = /*#__PURE__*/function () {
  function ProductAddToWishlist() {
    _classCallCheck(this, ProductAddToWishlist);
    _defineProperty(this, "addedToWishListEvent", 'Edition:AddedToWishlist');
    _defineProperty(this, "dataLayer", window.dataLayer);
    this.init = this.init.bind(this);
    this.listenForAddToWishlist = this.listenForAddToWishlist.bind(this);
  }
  return _createClass(ProductAddToWishlist, [{
    key: "init",
    value: function init() {
      this.listenForAddToWishlist();
    }
  }, {
    key: "listenForAddToWishlist",
    value: function listenForAddToWishlist() {
      var _this = this;
      document.addEventListener(this.addedToWishListEvent, function (event) {
        var details = event.detail;
        _this.pushAddToWishlistEvent(details);
      });
    }
  }, {
    key: "pushAddToWishlistEvent",
    value: function pushAddToWishlistEvent(details) {
      this.dataLayer.push({
        ecommerce: null
      });
      var addToWishlistEventObject = {
        event: 'edition_add_to_wishlist',
        ecommerce: {
          currency: window.Shopify.currency.active,
          value: 1,
          items: [{
            item_name: details.title,
            item_id: details.id,
            item_handle: details.handle,
            item_url: details.url
          }]
        }
      };
      (0,_utils_DatalayerHelpers__WEBPACK_IMPORTED_MODULE_0__["default"])(addToWishlistEventObject);
    }
  }]);
}();


/***/ }),

/***/ "./resources/scripts/components/DataLayer/ContactFormSubmit.ts":
/*!*********************************************************************!*\
  !*** ./resources/scripts/components/DataLayer/ContactFormSubmit.ts ***!
  \*********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ ContactFormSubmit)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// Datalayer Contact Form Submit
var ContactFormSubmit = /*#__PURE__*/function () {
  function ContactFormSubmit() {
    _classCallCheck(this, ContactFormSubmit);
    _defineProperty(this, "dataLayer", window.dataLayer);
    this.init = this.init.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.pushContactFormSubmitEventObject = this.pushContactFormSubmitEventObject.bind(this);
  }
  return _createClass(ContactFormSubmit, [{
    key: "init",
    value: function init() {
      var _this = this;
      // Get all contact forms that have more than one input field that is not hidden
      var contactForms = Array.from(document.querySelectorAll('form[action^="/contact"]')).filter(function (form) {
        return form.querySelectorAll('input:not([type="hidden"]), textarea').length > 1;
      });
      contactForms.forEach(function (form) {
        form.addEventListener('submit', function () {
          _this.handleSubmit(form);
        });
      });
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit(form) {
      var firstNameInput = form.querySelector('input[name="contact[Name]"');
      var emailInput = form.querySelector('input[name="contact[email]"]');
      var phoneInput = form.querySelector('input[name="contact[Phone number]"]');
      var firstName = firstNameInput ? firstNameInput.value || '' : '';
      var email = emailInput ? emailInput.value || '' : '';
      var phone = phoneInput ? phoneInput.value || '' : '';
      // Capturing the event in the contactFormSubmitEventObject
      var contactFormSubmitEventObject = {
        event: 'edition_contact_form_submit',
        customerFirstName: firstName,
        customerEmail: email,
        customerPhone: phone
      };
      this.pushContactFormSubmitEventObject(contactFormSubmitEventObject);
    }
  }, {
    key: "pushContactFormSubmitEventObject",
    value: function pushContactFormSubmitEventObject(contactFormSubmitEventObject) {
      this.dataLayer.push(contactFormSubmitEventObject);
    }
  }]);
}();


/***/ }),

/***/ "./resources/scripts/components/DataLayer/DataLayer.ts":
/*!*************************************************************!*\
  !*** ./resources/scripts/components/DataLayer/DataLayer.ts ***!
  \*************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ EditionDataLayer)
/* harmony export */ });
/* harmony import */ var _Login__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Login */ "./resources/scripts/components/DataLayer/Login.ts");
/* harmony import */ var _AccountRegister__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./AccountRegister */ "./resources/scripts/components/DataLayer/AccountRegister.ts");
/* harmony import */ var _ContactFormSubmit__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./ContactFormSubmit */ "./resources/scripts/components/DataLayer/ContactFormSubmit.ts");
/* harmony import */ var _NewsletterSubscribe__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./NewsletterSubscribe */ "./resources/scripts/components/DataLayer/NewsletterSubscribe.ts");
/* harmony import */ var _AddToWishlist__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./AddToWishlist */ "./resources/scripts/components/DataLayer/AddToWishlist.ts");
/* harmony import */ var _MediaInteractions__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./MediaInteractions */ "./resources/scripts/components/DataLayer/MediaInteractions.ts");
/* harmony import */ var _SessionDurationLogger__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./SessionDurationLogger */ "./resources/scripts/components/DataLayer/SessionDurationLogger.ts");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }







var EditionDataLayer = /*#__PURE__*/function () {
  function EditionDataLayer() {
    _classCallCheck(this, EditionDataLayer);
    _defineProperty(this, "login", new _Login__WEBPACK_IMPORTED_MODULE_0__["default"]());
    _defineProperty(this, "accountRegister", new _AccountRegister__WEBPACK_IMPORTED_MODULE_1__["default"]());
    _defineProperty(this, "contactFormSubmit", new _ContactFormSubmit__WEBPACK_IMPORTED_MODULE_2__["default"]());
    _defineProperty(this, "newsletterSubscribe", new _NewsletterSubscribe__WEBPACK_IMPORTED_MODULE_3__["default"]());
    _defineProperty(this, "addToWishlist", new _AddToWishlist__WEBPACK_IMPORTED_MODULE_4__["default"]());
    _defineProperty(this, "mediaInteractions", new _MediaInteractions__WEBPACK_IMPORTED_MODULE_5__["default"]());
    _defineProperty(this, "sessionDurationLogger", new _SessionDurationLogger__WEBPACK_IMPORTED_MODULE_6__["default"]());
    this.init = this.init.bind(this);
  }
  return _createClass(EditionDataLayer, [{
    key: "init",
    value: function init() {
      var _this = this;
      setTimeout(function () {
        _this.login.init();
        _this.accountRegister.init();
        _this.contactFormSubmit.init();
        _this.newsletterSubscribe.init();
        _this.addToWishlist.init();
        _this.mediaInteractions.init();
        _this.sessionDurationLogger.init();
      }, 1000);
    }
  }]);
}();


/***/ }),

/***/ "./resources/scripts/components/DataLayer/Login.ts":
/*!*********************************************************!*\
  !*** ./resources/scripts/components/DataLayer/Login.ts ***!
  \*********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ Login)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// Datalayer Login
var Login = /*#__PURE__*/function () {
  function Login() {
    _classCallCheck(this, Login);
    _defineProperty(this, "dataLayer", window.dataLayer);
    this.init = this.init.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.pushLoginEvent = this.pushLoginEvent.bind(this);
  }
  return _createClass(Login, [{
    key: "init",
    value: function init() {
      var _this = this;
      var loginForms = Array.from(document.querySelectorAll('form[action="/account/login"]'));
      if (loginForms.length >= 1) {
        loginForms.forEach(function (form) {
          form.addEventListener('submit', function () {
            _this.handleSubmit(form);
          });
        });
      }
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit(form) {
      var emailInput = form.querySelector('input[type="email"]');
      var email = emailInput.value || '';
      // Capturing the event in the loginEventObject
      var loginEventObject = {
        event: 'edition_login',
        loginMethod: 'email',
        customerEmail: email
      };
      this.pushLoginEvent(loginEventObject);
    }
  }, {
    key: "pushLoginEvent",
    value: function pushLoginEvent(loginEventObject) {
      this.dataLayer.push(loginEventObject);
    }
  }]);
}();


/***/ }),

/***/ "./resources/scripts/components/DataLayer/MediaInteractions.ts":
/*!*********************************************************************!*\
  !*** ./resources/scripts/components/DataLayer/MediaInteractions.ts ***!
  \*********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ MediaInteractions)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* eslint-disable */
// DataLayer Media Interactions
var MediaInteractions = /*#__PURE__*/function () {
  function MediaInteractions() {
    _classCallCheck(this, MediaInteractions);
    _defineProperty(this, "dataLayer", window.dataLayer);
    this.init = this.init.bind(this);
    this.listenForMediaInteractions = this.listenForMediaInteractions.bind(this);
  }
  return _createClass(MediaInteractions, [{
    key: "init",
    value: function init() {
      var _this = this;
      setTimeout(function () {
        _this.listenForMediaInteractions();
      }, 1000);
    }
  }, {
    key: "listenForMediaInteractions",
    value: function listenForMediaInteractions() {
      var mediaElements = Array.from(document.querySelectorAll('video, audio'));
      mediaElements.forEach(function (mediaElement) {
        mediaElement.addEventListener('play', function (event) {
          /* console.log('Media Play Event', event); */
        });
        mediaElement.addEventListener('pause', function (event) {
          /* console.log('Media Pause Event', event); */
        });
        mediaElement.addEventListener('volumechange', function (event) {
          /* if (mediaElement.muted) {
            console.log('Media Mute Event', event);
          } */
        });
      });
    }
  }]);
}();


/***/ }),

/***/ "./resources/scripts/components/DataLayer/NewsletterSubscribe.ts":
/*!***********************************************************************!*\
  !*** ./resources/scripts/components/DataLayer/NewsletterSubscribe.ts ***!
  \***********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ NewsletterSubscribe)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// Datalayer Newsletter Subscribe
var NewsletterSubscribe = /*#__PURE__*/function () {
  function NewsletterSubscribe() {
    _classCallCheck(this, NewsletterSubscribe);
    _defineProperty(this, "dataLayer", window.dataLayer);
    this.init = this.init.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.pushNewsletterSubscribeEventObject = this.pushNewsletterSubscribeEventObject.bind(this);
  }
  return _createClass(NewsletterSubscribe, [{
    key: "init",
    value: function init() {
      var _this = this;
      // Get all newsletter forms that only one input field that is not hidden
      var newsletterSubscribeForms = Array.from(document.querySelectorAll('form[action^="/contact"]')).filter(function (form) {
        return form.querySelectorAll('input:not([type="hidden"]), textarea').length === 1;
      });
      newsletterSubscribeForms.forEach(function (form) {
        form.addEventListener('submit', function () {
          _this.handleSubmit(form);
        });
      });
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit(form) {
      var emailInput = form.querySelector('input[name="contact[email]"]');
      var email = emailInput ? emailInput.value || '' : '';
      // Capturing the event in the newsletterSubscribeEventObject
      var newsletterSubscribeEventObject = {
        event: 'edition_newsletter_subscribe',
        customerEmail: email
      };
      this.pushNewsletterSubscribeEventObject(newsletterSubscribeEventObject);
    }
  }, {
    key: "pushNewsletterSubscribeEventObject",
    value: function pushNewsletterSubscribeEventObject(newsletterSubscribeEventObject) {
      this.dataLayer.push(newsletterSubscribeEventObject);
    }
  }]);
}();


/***/ }),

/***/ "./resources/scripts/components/DataLayer/SessionDurationLogger.ts":
/*!*************************************************************************!*\
  !*** ./resources/scripts/components/DataLayer/SessionDurationLogger.ts ***!
  \*************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ SessionDurationLogger)
/* harmony export */ });
/* harmony import */ var _utils_DatalayerHelpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../utils/DatalayerHelpers */ "./resources/scripts/utils/DatalayerHelpers.ts");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// Import pushToDataLayer helper function (as in your example)

// Define the custom web component class
var SessionDurationLogger = /*#__PURE__*/function () {
  function SessionDurationLogger() {
    _classCallCheck(this, SessionDurationLogger);
    _defineProperty(this, "maxTime", 300);
    _defineProperty(this, "logInterval", 30);
    _defineProperty(this, "lastLoggedTime", 0);
    _defineProperty(this, "intervalID", null);
    this.init = this.init.bind(this);
    this.startLogging = this.startLogging.bind(this);
    this.logElapsedTime = this.logElapsedTime.bind(this);
  }
  // Store the session start time if not already stored
  return _createClass(SessionDurationLogger, [{
    key: "init",
    value: function init() {
      if (!sessionStorage.getItem('gtm_session_start')) {
        sessionStorage.setItem('gtm_session_start', Date.now().toString());
      }
      this.startLogging();
    }
    // Function to start the interval timer for logging session duration
  }, {
    key: "startLogging",
    value: function startLogging() {
      var _this = this;
      this.intervalID = setInterval(function () {
        return _this.logElapsedTime();
      }, 1000); // Keep this if logging every second is needed
    }
    // Function to check elapsed time and log it if needed
  }, {
    key: "logElapsedTime",
    value: function logElapsedTime() {
      var startTime = parseInt(sessionStorage.getItem('gtm_session_start'), 10) || Date.now();
      var currentTime = Date.now();
      var elapsedTime = currentTime - startTime;
      var elapsedSeconds = Math.floor(elapsedTime / 1000);
      if (elapsedSeconds % this.logInterval === 0 && elapsedSeconds !== this.lastLoggedTime && elapsedSeconds <= this.maxTime) {
        // Prepare the dataLayer event object
        var eventObject = {
          event: 'engaged_session',
          session_duration: elapsedSeconds
        };
        // Push the event to the dataLayer
        (0,_utils_DatalayerHelpers__WEBPACK_IMPORTED_MODULE_0__["default"])(eventObject);
        // Update the last logged time
        this.lastLoggedTime = elapsedSeconds;
      }
      // Stop logging if the maximum time has been reached
      if (elapsedSeconds > this.maxTime) {
        clearInterval(this.intervalID);
        this.intervalID = null; // Reset to avoid stale references
      }
    }
  }]);
}();


/***/ }),

/***/ "./resources/scripts/components/ReadMoreCollection/ReadMoreCollection.ts":
/*!*******************************************************************************!*\
  !*** ./resources/scripts/components/ReadMoreCollection/ReadMoreCollection.ts ***!
  \*******************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ initReadMoreCollection)
/* harmony export */ });
function initReadMoreCollection() {
  function toggleReadMoreLess() {
    var readmore = document.querySelectorAll(".readmore-open");
    var readless = document.querySelectorAll(".readmore-close");
    var readmoreContent = document.querySelectorAll(".readmore-content");
    if (readmore && readless && readmoreContent) {
      readmore.forEach(function (readmoreBtn, index) {
        readmoreBtn.addEventListener("click", function (event) {
          event.preventDefault();
          readmoreContent.forEach(function (content) {
            return content.classList.remove("readmore-content");
          });
          readmore.forEach(function (btn) {
            return btn.classList.add("tw:hidden");
          });
          readmore.forEach(function (btn) {
            return btn.classList.remove("md:tw:flex");
          });
          readless[index].classList.remove("tw:hidden");
          readless[index].classList.add("md:tw:flex");
        });
      });
      readless.forEach(function (readlessBtn, index) {
        readlessBtn.addEventListener("click", function (event) {
          event.preventDefault();
          readmoreContent.forEach(function (content) {
            return content.classList.add("readmore-content");
          });
          readless.forEach(function (btn) {
            return btn.classList.add("tw:hidden");
          });
          readless.forEach(function (btn) {
            return btn.classList.remove("md:tw:flex");
          });
          readmore[index].classList.remove("tw:hidden");
          readmore[index].classList.add("md:tw:flex");
        });
      });
    }
  }
  document.addEventListener("DOMContentLoaded", toggleReadMoreLess);
  window.addEventListener("resize", toggleReadMoreLess);
}

/***/ }),

/***/ "./resources/scripts/components/VideoReviews/VideoReviews.ts":
/*!*******************************************************************!*\
  !*** ./resources/scripts/components/VideoReviews/VideoReviews.ts ***!
  \*******************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ VideoReviews)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var VideoReviews = /*#__PURE__*/function (_HTMLElement) {
  function VideoReviews() {
    var _this;
    _classCallCheck(this, VideoReviews);
    _this = _callSuper(this, VideoReviews);
    _defineProperty(_this, "videoContainers", void 0);
    _defineProperty(_this, "playbutton", void 0);
    _this.toggleVideo = _this.toggleVideo.bind(_this);
    return _this;
  }
  _inherits(VideoReviews, _HTMLElement);
  return _createClass(VideoReviews, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this2 = this;
      this.videoContainers = this.querySelectorAll(".video-container");
      this.videoContainers.forEach(function (container) {
        container.addEventListener("click", _this2.toggleVideo);
      });
    }
    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "playVideo",
    value: function playVideo(video, container) {
      this.playbutton = container.querySelectorAll(".play-button");
      container.querySelector(".video-poster").classList.add("tw:hidden");
      container.querySelector(".video-main").classList.remove("tw:hidden");
      this.playbutton.forEach(function (button) {
        return button.classList.add("tw:hidden!");
      });
      video.play();
    }
    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "pauseVideo",
    value: function pauseVideo(video, container) {
      this.playbutton = container.querySelectorAll(".play-button");
      container.querySelector(".video-main").classList.add("tw:hidden");
      container.querySelector(".video-poster").classList.remove("tw:hidden");
      this.playbutton.forEach(function (button) {
        return button.classList.remove("tw:hidden!");
      });
      video.pause();
    }
  }, {
    key: "toggleVideo",
    value: function toggleVideo(event) {
      var _this3 = this;
      var container = event.currentTarget;
      var video = container.querySelector(".video-main video");
      if (!video) return;
      if (video.paused) {
        this.videoContainers.forEach(function (otherContainer) {
          if (otherContainer === container) return;
          var otherVideo = otherContainer.querySelector(".video-main video");
          if (otherVideo && !otherVideo.paused) {
            _this3.pauseVideo(otherVideo, otherContainer);
          }
        });
        this.playVideo(video, container);
      } else {
        this.pauseVideo(video, container);
      }
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ }),

/***/ "./resources/scripts/utils/DatalayerHelpers.ts":
/*!*****************************************************!*\
  !*** ./resources/scripts/utils/DatalayerHelpers.ts ***!
  \*****************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ pushToDataLayer)
/* harmony export */ });
window.dataLayer = window.dataLayer || [];
// Function to push the event to the datalayer.
// If something goes wrong and the event does not get pushed, we check again after a set interval and try to push again.
function pushToDataLayer(object) {
  window.dataLayer.push(object);
  var intervalId = setInterval(function () {
    var isEventPushed = window.dataLayer.includes(object);
    if (!isEventPushed) {
      window.dataLayer.push(object);
    } else {
      clearInterval(intervalId);
    }
  }, 750);
}

/***/ }),

/***/ "./resources/styles/app.css":
/*!**********************************!*\
  !*** ./resources/styles/app.css ***!
  \**********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn, priority) => {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var [chunkIds, fn, priority] = deferred[i];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			"/shopify-theme/assets/edition": 0,
/******/ 			"shopify-theme/assets/edition": 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunkvivelli_b2c"] = self["webpackChunkvivelli_b2c"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	__webpack_require__.O(undefined, ["shopify-theme/assets/edition"], () => (__webpack_require__("./resources/app.ts")))
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, ["shopify-theme/assets/edition"], () => (__webpack_require__("./resources/styles/app.css")))
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;